import { render, staticRenderFns } from "./EventsView.vue?vue&type=template&id=6c92e8d3&scoped=true&"
import script from "./EventsView.vue?vue&type=script&lang=js&"
export * from "./EventsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c92e8d3",
  null
  
)

export default component.exports